import PAText from "component/design-system/typography/PAText/PAText";
import ArticleItem from "component/landing-page/article-item/ArticleItem";
import HideIf from "util/HideIf";

export default function ProductDescription(props) {
  const { productDescription, sku } = props;

  return (
    <>
      {productDescription?.map((description, idx) => {
        const { article } = description;
        return (
          <ArticleItem
            key={idx}
            content={article.content}
          />
        );
      })}

      <HideIf show={sku}>
        <PAText component="p">
          {`SKU: ${sku}`}
        </PAText>
      </HideIf>
    </>
  );
}
